import React from 'react';

import Chip from '@gogame/ui/Chip';
import Stack from '@gogame/ui/Stack';

const FileItem = ({ label, onDelete, disabled }) => {
  return (
    <Stack p={0.5} zeroMinWidth={true}>
      <Chip
        label={label}
        ellipsis={true}
        onDelete={onDelete}
        disabled={disabled}
      />
    </Stack>
  );
};

export default FileItem;
